import React from "react";
import { Form, InputNumber } from "antd";

export default function NumberInputField({ name, label, value, setValue, onBlur, disabled=false, min = 0, max = undefined, step=1, getFieldErrors, style = { width: "100%" }, keyNum, placeholder = '' }) {
  const fieldErrors = (typeof keyNum !== "undefined") ? getFieldErrors(name, keyNum) :  getFieldErrors(name);

  const onChange = (value) => {
    setValue(value);
  };

  if (fieldErrors) {
    return (
      <React.Fragment>
        <span className="form-field-label" htmlFor={name}>
          {label}
        </span>
        <Form.Item validateStatus="error" help={fieldErrors}>
          <InputNumber
            min={min}
            max={max}
            size="large"
            name={name}
            id={name}
            placeholder={label || placeholder}
            defaultValue={value}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            style={style}
            step={step}
            disabled={disabled}
          />
        </Form.Item>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <span className="form-field-label" htmlFor={name}>
          {label}
        </span>
        <InputNumber
          min={min}
          max={max}
          size="large"
          name={name}
          id={name}
          placeholder={label || placeholder}
          defaultValue={value}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          style={style}
          step={step}
          disabled={disabled}
        />
      </React.Fragment>
    );
  }
}
